import {
  Button,
  Menu,
  MenuItem,
  MenuList,
  Stack,
  styled,
  Typography,
} from '@mui/material'
import Box from '@mui/material/Box'
import { Client } from '../../models/Organization'
import { calculateAge } from '../../utils/Common'
import { useNavigate } from 'react-router-dom'
import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../store'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import { deleteClientAsync } from '../../services/clientsService'
import { CustomMenuList } from '../CustomMenuListComponent'

const projectImages = [
  '/images/projectExample1.png',
  '/images/projectExample2.png',
  '/images/projectExample3.png',
  '/images/projectExample4.png',
  '/images/projectExample5.png',
  '/images/projectExample6.png',
]

const projectsSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.projects,
)

interface ClientCardProps {
  client: Client
}

const ClientCardComponent: React.FC<ClientCardProps> = ({ client }) => {
  const dispatch = useDispatch<any>()
  const navigate = useNavigate()
  const [contextMenu, setContextMenu] = useState<
    { mouseX: number; mouseY: number } | undefined
  >()
  const projects = useSelector(projectsSelector)
  const clientProjects = projects.filter(
    (project) => project.client_id === client.id,
  )

  const handleClientClick = () => {
    if (!Boolean(contextMenu)) {
      navigate(`/clients/${client.id}/projects`)
    }
  }

  const handleClientContextMenu = (
    event: React.MouseEvent<HTMLButtonElement>,
  ) => {
    event.preventDefault()
    setContextMenu(
      !Boolean(contextMenu)
        ? { mouseX: event.clientX - 2, mouseY: event.clientY - 4 }
        : undefined,
    )
    const selection = document.getSelection()
    if (selection && selection.rangeCount > 0) {
      const range = selection.getRangeAt(0)

      setTimeout(() => {
        selection.addRange(range)
      })
    }
  }

  const handleClose = () => {
    setContextMenu(undefined)
  }

  const handleDeleteClientClick = () => {
    dispatch(deleteClientAsync({ clientId: client.id }))
    handleClose()
  }

  return (
    <Button
      onClick={handleClientClick}
      onContextMenu={handleClientContextMenu}
      sx={{
        display: 'flex',
        width: '100%',
        boxSizing: 'border-box',
        p: '1rem',
        background: '#F5F5F5',
        boxShadow: '0px 3px 10px 0px #0000001A',
        border: '1px solid #DBDBDB',
        borderRadius: '0.4rem',
        textAlign: 'left',
        textTransform: 'none',
      }}
    >
      <Stack gap='1.5rem' width='100%'>
        <Box>
          <Typography
            sx={{
              color: '#04002E',
              fontSize: '0.88rem',
              fontWeight: 500,
              lineHeight: 'normal',
            }}
          >
            {client.name}
          </Typography>
        </Box>
        <Box
          display='flex'
          gap='0.5rem'
          sx={{ width: '100%', height: '4rem', overflowX: 'hidden' }}
        >
          {clientProjects.map((project, index) => (
            <Box
              key={index}
              component='img'
              src={projectImages[index % projectImages.length]}
              alt='Project Thumbnail'
              sx={{
                width: '5rem',
                borderRadius: '2px',
                flexShrink: 0,
              }}
            ></Box>
          ))}
        </Box>
        <Box
          display='flex'
          width='100%'
          alignItems='center'
          justifyContent='space-between'
        >
          <Typography
            component='div'
            sx={{
              fontWeight: 500,
              fontSize: '0.82rem',

              color: '#04002E',
            }}
          >
            {`${clientProjects.length} ${clientProjects.length === 1 ? 'Project' : 'Projects'}`}
          </Typography>
          <Typography
            component='div'
            sx={{
              fontWeight: 500,
              fontSize: '0.58rem',

              color: '#04002E',
            }}
          >
            Updated: {calculateAge(client?.updatedAt ?? Date.now().toString())}
          </Typography>
        </Box>
      </Stack>
      <Menu
        open={Boolean(contextMenu)}
        onClose={handleClose}
        anchorReference='anchorPosition'
        anchorPosition={
          contextMenu
            ? { left: contextMenu.mouseX, top: contextMenu.mouseY }
            : undefined
        }
        MenuListProps={{
          disablePadding: true,
          component: CustomMenuList,
        }}
        slotProps={{
          paper: {
            sx: {
              border: 'none',
              padding: 0,
              width: '7rem',
            },
          },
        }}
      >
        <MenuItem onClick={() => {}}>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography
              sx={{
                fontSize: '0.64rem',
                fontStyle: 'normal',
                fontWeight: 500,
                lineHeight: 'normal',
              }}
            >
              Move
            </Typography>
          </Box>
        </MenuItem>
        <MenuItem onClick={handleDeleteClientClick}>
          <Box
            sx={{
              width: '100%',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
            }}
          >
            <Typography
              sx={{
                fontSize: '0.64rem',
                fontStyle: 'normal',
                fontWeight: 500,
                lineHeight: 'normal',
              }}
            >
              Delete
            </Typography>
          </Box>
        </MenuItem>
      </Menu>
    </Button>
  )
}

export default ClientCardComponent
